<div class="flex h-16 items-center justify-end gap-5 border-b border-slate-200 bg-white px-6">
  @if (currentUserService.hasTimesheetAccess()) {
    <elcia-timesheet-timer/>
    <span class="h-6 w-px bg-slate-200" aria-hidden="true"></span>
  }
  <elcia-invoicing-alert *canAccessFinances/>
  <elcia-bell-notification/>
  <elcia-my-profile/>
</div>
